import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/AuthContext";

import Home from "./pages/Home";
import Category from "./pages/Category";
import Article from "./pages/Article";
import Search from "./pages/Search";
import Archive from "./pages/Archive";
import Author from "./pages/Author";
import Breaking from "./pages/Breaking";
import VideoNews from "./pages/VideoNews";
import About from "./pages/About";
import SubmitTip from "./pages/SubmitTip";
import StaticPage from "./pages/StaticPage";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import ArticlesAdmin from "./pages/admin/ArticlesAdmin";
import ArticleEditor from "./pages/admin/ArticleEditor";
import ReviewQueue from "./pages/admin/ReviewQueue";
import TipsAdmin from "./pages/admin/TipsAdmin";
import FeedsAdmin from "./pages/admin/FeedsAdmin";
import MediaLibrary from "./pages/admin/MediaLibrary";
import AdminProfile from "./pages/admin/AdminProfile";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/category/:slug" element={<Category />} />
          <Route path="/article/:slug" element={<Article />} />
          <Route path="/search" element={<Search />} />
          <Route path="/archive" element={<Archive />} />
          <Route path="/author/:slug" element={<Author />} />
          <Route path="/breaking" element={<Breaking />} />
          <Route path="/video" element={<VideoNews />} />
          <Route path="/about" element={<About />} />
          <Route path="/submit-tip" element={<SubmitTip />} />
          <Route path="/page/:slug" element={<StaticPage />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="articles" element={<ArticlesAdmin />} />
            <Route path="articles/new" element={<ArticleEditor />} />
            <Route path="articles/:id" element={<ArticleEditor />} />
            <Route path="review" element={<ReviewQueue />} />
            <Route path="tips" element={<TipsAdmin />} />
            <Route path="feeds" element={<FeedsAdmin />} />
            <Route path="media" element={<MediaLibrary />} />
            <Route path="profile" element={<AdminProfile />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
